module.exports = __webpack_public_path__ + "static/media/logo_dev.289fe23b.webp";